import { Layout, LayoutProps } from 'antd';
import styled from 'styled-components';

interface LayoutContainerProps extends LayoutProps {
  isDisplayedInIframe?: boolean;
}

export const LayoutContainer = styled(Layout)<LayoutContainerProps>`
  ${(props) =>
    !props.isDisplayedInIframe &&
    `
    min-height: 100vh;
    height: 100%;
  `}
  min-width: 1425px;

  .ant-layout-sider {
    background: ${({ theme }) => theme.colorBgBase};
    transition: none;
  }
`;
